var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 134,
    viewBox: "0 0 100 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_167_11)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0805 12.2554C48.6076 11.3081 51.3924 11.3081 53.9195 12.2554L93.0028 26.9117C95.1318 27.7097 96.9664 29.1386 98.2615 31.0074C99.5565 32.8761 100.25 35.0956 100.25 37.3693V67.3127C100.25 76.6448 97.6517 85.7926 92.7456 93.7311C87.8396 101.67 80.8198 108.085 72.4729 112.259L53.7464 121.616C52.5832 122.198 51.3006 122.501 50 122.501C48.6994 122.501 47.4168 122.198 46.2536 121.616L27.5271 112.253C19.1802 108.079 12.1605 101.664 7.25439 93.7255C2.34832 85.787 -0.250199 76.6392 -0.249998 67.3071V37.3748C-0.251418 35.1003 0.441806 32.8795 1.73693 31.0097C3.03206 29.1398 4.86731 27.7101 6.99717 26.9117L46.0805 12.2554ZM55.5833 65.5037C57.712 64.2745 59.3757 62.3774 60.3163 60.1064C61.2569 57.8354 61.4219 55.3175 60.7857 52.9432C60.1495 50.5688 58.7476 48.4708 56.7975 46.9744C54.8474 45.4779 52.4581 44.6668 50 44.6667C47.5419 44.6668 45.1526 45.4779 43.2025 46.9744C41.2524 48.4708 39.8505 50.5688 39.2143 52.9432C38.5781 55.3175 38.7431 57.8354 39.6837 60.1064C40.6243 62.3774 42.288 64.2745 44.4167 65.5037V83.75C44.4167 85.2308 45.0049 86.6509 46.052 87.698C47.0991 88.7451 48.5192 89.3333 50 89.3333C51.4808 89.3333 52.9009 88.7451 53.948 87.698C54.9951 86.6509 55.5833 85.2308 55.5833 83.75V65.5037Z",
    fill: "#3F3F97"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_167_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 134,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafe);
export default __webpack_public_path__ + "static/media/safe.8c7ba7d2c6ac3da937fe1188f46c4d47.svg";
export { ForwardRef as ReactComponent };